import { createApp } from 'vue'
import App           from "./App.vue";
import store         from "./store";

export default class Form
{


    static launch ( strSelector, form )
    {

        let el = document.querySelector( strSelector );

        const vue = createApp( App );

        vue
            .provide( 'copydeck', __copydeck__.form )
            .provide( 'form', form )
            .provide( 'pk_stripe', __pk_stripe__ ?? "" )
            .use( store )
            .mount( el );
    }


}




